import * as ActionTypes from '../actions/actionTypes';
import {WIND_DATA_STATUS} from '../Constants';
import {calculateBarbData, calculateVelocityData} from '../utils/wind_utils';

const initialState = {
  barb_data: null,
  velocity_data: null,
  magnitude_data: {},
  direction_data: {},
  all_barb_data: {},
  all_velocity_data: {},
  status: WIND_DATA_STATUS.NOT_LOADED
};

const calculateData = (state, action) => {
  if (state.direction_data[action.time] && state.magnitude_data[action.time]) {
    state.all_barb_data[action.time] = calculateBarbData(state.magnitude_data[action.time],
      state.direction_data[action.time],
      action.map_bounds,
      action.map_zoom,
      action.time);
    state.all_velocity_data[action.time] = calculateVelocityData(state.magnitude_data[action.time],
      state.direction_data[action.time]);
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CLEAR_WIND_DATA:
      return initialState;
    case ActionTypes.WIND_DATA_LOAD_STARTING:
      return { ...state, status: WIND_DATA_STATUS.LOADING };
    case ActionTypes.WIND_DATA_LOAD_COMPLETE:
      return { ...state, status: WIND_DATA_STATUS.LOADED };
    case ActionTypes.POPULATE_MAGNITUDE_DATA: {
      let newState = {
        ...state,
        magnitude_data: { ...state.magnitude_data, [action.time]: action.data }
      };
      calculateData(newState, action);
      return newState;
    }
    case ActionTypes.POPULATE_DIRECTION_DATA: {
      let newState = {
        ...state,
        direction_data: { ...state.direction_data, [action.time]: action.data }
      };
      calculateData(newState, action);
      return newState;
    }
    case ActionTypes.SET_VELOCITY_DATA:
      return {
        ...state,

        velocity_data: state.all_velocity_data[action.time]
      };

    case ActionTypes.SET_BARB_DATA:
      return {
        ...state,
        barb_data: state.all_barb_data[action.time]
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/wind_data.js